import http from "@web-app/utils/http";

export type DevCheatOrderType =
  "single-dropoff" | "single-p2p" | "single-pickup";
export type DevCheatRouteType = "first-mile" | "last-mile";

export interface DevCheatOrderPayload {
  date: string; // Date in YYYY-MM-DD format
}

export interface DevCheatRoutePayload {
  date: string; // Date in YYYY-MM-DD format
  orderCount?: number; // default 5 on backend
}

export interface DevOrderResponse {
  message: string;
  orderId: string;
}

export interface DevRouteResponse {
  message: string;
  orderIds: string[];
  routeId: string;
}

export const createDevOrder = (
  type: DevCheatOrderType,
  payload: DevCheatOrderPayload,
) => {
  return http
    .post<DevOrderResponse>(`/devCheat/orders/${type}`, payload)
    .then((response) => response.data);
};

export const createDevRoute = (
  type: DevCheatRouteType,
  payload: DevCheatRoutePayload,
) => {
  return http
    .post<DevRouteResponse>(`/devCheat/routes/${type}`, payload)
    .then((response) => response.data);
};
